import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const SparkleIcon = React.memo(function SparkleIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 1C7.5 4.58985 10.4101 7.5 14 7.5C10.4101 7.5 7.5 10.4101 7.5 14C7.5 10.4101 4.58985 7.5 1 7.5C4.58985 7.5 7.5 4.58985 7.5 1Z"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
});
